import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler } from '@angular/common/http';
import { Observable, from, of } from 'rxjs';
import { JwtTokenService } from './jwtToken.service';
import { OAuthService } from './oauth.service';
import { OAuthResponseModel } from 'src/app/shared/models/response/oauth-response.model';
import { environment } from 'src/environments/environment';
import { mergeMap, scan, delay, retryWhen, switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService {
  ignorarUrlContem = ['viacep'];
  oauthResp: OAuthResponseModel;
  LCOauthKey = 'OauthToken';
  respOAuth$: any;

  constructor(
    public jwtTokenService: JwtTokenService,
    public oauthService: OAuthService,
    private authService: AuthService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return from(this.handle(req, next));
  }

  async handle(request: HttpRequest<any>, next: HttpHandler) {
    if (!request.headers.get('skip')) {
      const token = this.jwtTokenService.getLocalToken();
      const ignorarUrl = this.ignorarUrlContem.some((e) => request.url.indexOf(e) >= 0);
      if (!token && !ignorarUrl) {
        request = this.tratarRequestApiMcea(request, token);
        if (this.outhTokeIsExpired()) {
          request = await this.getOAuthToken(request);
        } else {
          request = this.tratarRequestOAuth(request);
        }
      }

      if (token && !ignorarUrl) {
        request = this.tratarRequestApiMcea(request, token);

        if (this.jwtTokenService.visualizandoLoja()) {
          request = this.tratarRequestVisualizarComo(request);
        }

        if (this.outhTokeIsExpired()) {
          request = await this.getOAuthToken(request);
        } else {
          request = request = this.tratarRequestOAuth(request);
        }
      }
    }

    return next
      .handle(request)
      .pipe(retryWhen((e) => this.retryWhenHandler(request, e)))
      .toPromise();
  }

  async getHeader() {
    const response = await this.oauthService.getAccessToken().toPromise();
    const token = this.jwtTokenService.getLocalToken();
    const headers: any = {
      Authorization: `${response.token_type} ${response.access_token}`,
      'MCEA-AccessToken': `Bearer ${token}`,
      'MCEA-Key': environment.MceaKey
    };
    return { headers };
  }

  private retryWhenHandler(
    request: HttpRequest<any>,
    obs: Observable<any>,
    opt: any = { retryCount: 1, delay: 1000, retryStatus: [503, 401] }
  ): Observable<any> {
    return obs
      .pipe(
        switchMap(async (resp) => {
          await this.authService.refreshToken().toPromise();
          if (this.outhTokeIsExpired()) {
            await this.getOAuthToken(request);
          }
          return resp;
        })
      )
      .pipe(
        mergeMap((resp) => {
          if (opt?.retryStatus?.indexOf(resp.status) >= 0) {
            return of(resp);
          }
          throw resp;
        }),
        scan((acc, error) => {
          if (acc >= opt?.retryCount) {
            throw error;
          }
          return acc + 1;
        }, 0),
        delay(opt?.delay)
      );
  }

  private async getOAuthToken(request: HttpRequest<any>) {
    if (!this.respOAuth$) {
      this.respOAuth$ = this.oauthService.getAccessToken().toPromise();
    }
    const response = await this.respOAuth$;
    this.respOAuth$ = null;
    request = this.tratarRequestOAuth(request, response);
    return request;
  }

  private outhTokeIsExpired(): boolean {
    if (!this.oauthResp) {
      return true;
    }
    const dataAtual = new Date().getTime();
    const dataToken = this.oauthResp?.dataRequest?.getTime();
    const dif = dataAtual - dataToken;
    const sec = Math.round(dif / 1000) + 10;
    const bool = sec > this.oauthResp?.expires_in;
    return bool;
  }

  private tratarRequestVisualizarComo(request: HttpRequest<any>) {
    const afiliadoId = this.jwtTokenService.getIdAfiliado();
    const nome = this.jwtTokenService.getDominioLoja();
    request = request.clone({
      setHeaders: {
        visualizarComo: `{"afiliadoId": "${afiliadoId}", "nome" : "${nome}"}`
      }
    });
    return request;
  }

  private tratarRequestApiMcea(request: HttpRequest<any>, token: string) {
    let headers: any = {
      'MCEA-AccessToken': `Bearer ${token}`
    };
    headers = {
      ...headers,
      'MCEA-Key': environment.MceaKey
    };
    request = request.clone({
      setHeaders: headers
    });
    return request;
  }

  private tratarRequestOAuth(request: HttpRequest<any>, response?: OAuthResponseModel) {
    if (response) {
      this.oauthResp = response;
      this.oauthResp.dataRequest = new Date();
    }
    if (this.oauthResp) {
      request = request.clone({
        setHeaders: {
          Authorization: `${this.oauthResp.token_type} ${this.oauthResp.access_token}`
        }
      });
    }
    return request;
  }
}
